module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/97dba457a969428a069a2baf0ade1e4e.png";